/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
      componentRegistry.setComponentDebug('HeaderDescription', true);
        componentRegistry.useComponentPlugin('HeaderDescription', {
            name: 'Modify Header Description',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                  const headerDescriptionElm = element.getRootElm();
                  if (headerDescriptionElm) {
                    headerDescriptionElm.querySelectorAll('a').forEach(link => {
                      if (link) {
                        link.setAttribute('target', '_blank');
                      }
                    });
                  }
                },
            }),
        });
    }
]);